module.exports = __webpack_public_path__ + "img/Insert2.dadd92e6.jpg";